/* =====================================================================
   Juxta Baby — motion (non-render-blocking, re-inits on section load)
   ===================================================================== */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Scroll reveal ---- */
  var io = null;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.jxf-reveal:not(.is-visible)');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Hero slideshow ---- */
  function initHero(root) {
    (root || document).querySelectorAll('[data-jxf-hero]').forEach(function (hero) {
      if (hero.__jxfInit) return;
      hero.__jxfInit = true;
      var slides = Array.prototype.slice.call(hero.querySelectorAll('.jxf-hero__slide'));
      var dots = Array.prototype.slice.call(hero.querySelectorAll('.jxf-hero__dot'));
      if (slides.length < 2) return;
      var i = 0, timer = null;
      var delay = parseInt(hero.getAttribute('data-jxf-hero'), 10) || 6000;
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
        dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
      }
      function start() { if (reduced) return; stop(); timer = setInterval(function () { show(i + 1); }, delay); }
      function stop() { if (timer) clearInterval(timer); }
      dots.forEach(function (d, idx) { d.addEventListener('click', function () { show(idx); start(); }); });
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
      show(0); start();
    });
  }

  /* ---- Tabs (product tabs + any [data-jxf-tabs]) ---- */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-jxf-tabs]').forEach(function (group) {
      if (group.__jxfInit) return;
      group.__jxfInit = true;
      var tabs = Array.prototype.slice.call(group.querySelectorAll('.jxf-tab'));
      var panels = Array.prototype.slice.call(group.querySelectorAll('.jxf-tabs__panel'));
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var id = tab.getAttribute('data-jxf-tab');
          tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); t.setAttribute('aria-selected', t === tab); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-jxf-panel') === id); });
        });
      });
    });
  }

  /* ---- Announcement bar rotator ---- */
  function initAnnounce(root) {
    (root || document).querySelectorAll('[data-jxf-announce]').forEach(function (bar) {
      if (bar.__jxfInit) return;
      bar.__jxfInit = true;
      var items = Array.prototype.slice.call(bar.querySelectorAll('.jxf-announce__item'));
      if (items.length < 2) return;
      var i = 0, timer = null;
      function show(n) { i = (n + items.length) % items.length; items.forEach(function (it, idx) { it.classList.toggle('is-active', idx === i); }); }
      function start() { if (reduced) return; stop(); timer = setInterval(function () { show(i + 1); }, 4500); }
      function stop() { if (timer) clearInterval(timer); }
      var prev = bar.querySelector('[data-jxf-announce-prev]');
      var next = bar.querySelector('[data-jxf-announce-next]');
      if (prev) prev.addEventListener('click', function () { show(i - 1); start(); });
      if (next) next.addEventListener('click', function () { show(i + 1); start(); });
      show(0); start();
    });
  }

  /* ---- Mobile nav drawer (custom header) ---- */
  function initNav(root) {
    (root || document).querySelectorAll('[data-jxf-nav-toggle]').forEach(function (btn) {
      if (btn.__jxfInit) return;
      btn.__jxfInit = true;
      btn.addEventListener('click', function () {
        var open = document.documentElement.classList.toggle('jxf-nav-open');
        btn.setAttribute('aria-expanded', open);
        document.body.style.overflow = open ? 'hidden' : '';
      });
    });
    (root || document).querySelectorAll('[data-jxf-nav-close]').forEach(function (btn) {
      if (btn.__jxfInit) return;
      btn.__jxfInit = true;
      btn.addEventListener('click', function () {
        document.documentElement.classList.remove('jxf-nav-open');
        document.body.style.overflow = '';
      });
    });
    // mobile accordion submenus
    (root || document).querySelectorAll('[data-jxf-acc]').forEach(function (btn) {
      if (btn.__jxfInit) return;
      btn.__jxfInit = true;
      btn.addEventListener('click', function () {
        var li = btn.closest('.jxf-mnav__item');
        if (li) li.classList.toggle('is-open');
      });
    });
  }

  function initAll(root) { initReveal(root); initHero(root); initTabs(root); initAnnounce(root); initNav(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Theme editor: re-init when a section reloads */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initHero(e.target); });
})();
